
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const PropertyNotFound = () => {
  return (
    <div className="flex-grow flex flex-col items-center justify-center py-16 px-4 bg-white">
      <h1 className="text-3xl font-bold text-gray-800 mb-4">Property not found</h1>
      <p className="text-gray-600 mb-8 text-center max-w-md">
        The property you're looking for doesn't exist or has been removed.
      </p>
      <Button asChild>
        <Link to="/properties">Browse Properties</Link>
      </Button>
    </div>
  );
};

export default PropertyNotFound;
